import React, { useState } from "react";
import styles from "./TextBlock.module.scss";
import Layout from "../../layouts/Layout/Layout";
import THEME from "../../../state/theme";
import { Button } from "../../elements";
import { useCustomState } from "../../../state/state";
import Carousel from 'nuka-carousel';
import More from './More';
import First from '../../../assets/vysion1.png';
import Second from '../../../assets/vysion2.png';
import Third from '../../../assets/vysion3.png';

export default () => {
  const [state, actions] = useCustomState();
  const [read, setRead] = useState(false);
  const [modal, setModal] = useState(false);

  const handleOpen = () => {
    setModal(true);
  }

  const handleClose = () => {
    setModal(false);
  }

  return (
    <>
      <Layout col="2" padding>
        <article className={styles.wrapper}>
          <div className={styles.info}>
            <span className={styles.subtitle} style={{ color: THEME.color }}>
              Startup info
            </span>
            <h2>Vysion Technology</h2>
            <p className={styles.paragraph}>
              Vysion Technology is a technology startup incubated by the Gujarat government under the SSIP initiative. The startup team comprises young and skilled enthusiasts from IITs, NITs, and IIITs working and innovating tirelessly in trendy terrains of IoT, Artificial Intelligence, Mobile/Web Applications, and Cloud. Our vision is to empower the nation by providing simple solutions to complex problems that would empower India in becoming the World Leader. We aim to deliver smarter and affordable solutions to build a better architecture of the future India, where the cities and industries are thorough smart and green and digital education is flourishing.
            </p>
            <p className={styles.paragraph}>
              <b>
                Uniquely innovate exceptional leadership skills whereas
                multidisciplinary paradigms. Energistically synergy whereas
                interactive schemas.
              </b>
            </p>
            <div className={styles.btn_box}>
              <div>
                <Button hoverType="solid-gray-tb" click={handleOpen}>
                  Read {modal ? "less" : "more"}
                </Button>
              </div>

            </div>
          </div>
        </article>
        <article className={styles.wrapper}>
          <figure className={styles.image}>
            <div
              className={styles.rectangle}
              style={{ borderColor: THEME.color }}
            />
            <div className={styles.photo}>
              <span
              // style={{
              //   background:
              //     "url(" +
              //     state.data.header_bgs.about_video_poster +
              //     ") center/cover",
              // }}
              >
                <Carousel
                  autoplay='true'
                  wrapAround='true'
                  className={styles.caro}
                >
                  <div className={styles.imgdiv}><img src={First} /></div>
                  <div className={styles.imgdiv}><img src={Second} /></div>
                  <div className={styles.imgdiv}><img src={Third} /></div>
                </Carousel>
              </span>
            </div>
          </figure>
        </article>
      </Layout>

      <More modal={modal} handleClose={handleClose} info={0} />
    </>
  );
};
